<template>
  <div class="minimart-frontend">
    <NavBar />
    <v-main>
      <v-container class="pb-5">
        <transition name="fade" mode="out-in" appear>
          <slot />
        </transition>
      </v-container>
    </v-main>
    <Footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'

export default {
  name: 'DefaultLayout',
  components: { NavBar, Footer },
  props: {
    layout: String,
  },
  data: () => ({
    //
  }),
  computed: {},
}
</script>
